import { render } from "./App.vue?vue&type=template&id=10b6bcdf"
const script = {}

import "./App.vue?vue&type=style&index=0&id=10b6bcdf&lang=css"
script.render = render

export default script